// ShellTop — a frame's pinned top block: the project-scope STRIPS stacked over
// the frame's BAR, as ONE block that measures itself (lib/shellTop — the one
// owner of "where the top chrome ends"; FRONTEND-PATTERNS §Navigation / shell).
//
// One block, not a sticky strip plus a sticky bar: the chrome sits at the
// window's top whatever the scroll, and its height is ONE number — what the
// peek, the section rails, a pinned thead and the condensed bar all read.
//
// `pinned` (default) = `sticky top-0` for a frame whose page is the window's
// scroll (AuthedLayout). A frame that scrolls INSIDE itself (FocusedFrame — a
// flex column with its own scroller) passes `pinned={false}`: the block is a
// fixed flex row there and still measures itself, so anything positioned
// against the window stays true in both frames.
//
// The canvas backing is load-bearing: a severity strip's fill is a translucent
// tint, and page content scrolls UNDER a pinned block.

import { useRef, type ReactNode } from 'react';
import { useShellTopMeasure } from '../../lib/shellTop.js';

export interface ShellTopProps {
  /** The project-scope strips, broadest on top (`ProjectStrips`). Renders nothing when none applies. */
  strips?: ReactNode;
  /** The frame's bar (the Navbar · the focused frame's bar). */
  children: ReactNode;
  pinned?: boolean;
}

export function ShellTop({ strips, children, pinned = true }: ShellTopProps) {
  const blockRef = useRef<HTMLDivElement>(null);
  const stripsRef = useRef<HTMLDivElement>(null);
  useShellTopMeasure(blockRef, stripsRef);
  return (
    <div ref={blockRef} className={`${pinned ? 'sticky top-0 z-nav' : 'shrink-0'} bg-[var(--color-canvas)]`}>
      <div ref={stripsRef}>{strips}</div>
      {children}
    </div>
  );
}
